<template>
  <div class="Header" :class="{ 'Header--menuOpened': menuOpened }">
    <div
            class="Header-menu"
            v-if="browserContext.down('lg') && browserContext.up('md')"
            @click="toggleMenu"
    >
      <ubi-icon
              :name="menuOpened ? 'close' : 'menu'"
              class="Header-menu-icon"
      />
    </div>
    <div>
      <router-link
          :to="{ name: 'dashboard' }"
          class="HeaderItems-item Header-logo"
      >
        <img
            alt=""
            :src="require(`@/assets/${logoCustomerSpace}.png`)"
            class="Header-logo-img"
            :srcset="require(`@/assets/${logoCustomerSpace}@2x.png`) + ' 2x'"
        />
      </router-link>
    </div>
    <div class="sponsorship">
        <p v-if="sitimmoUser.univers === 'IMMO'"><a class="link-sponsorship" target="_blank" href="https://www.ubiflow.net/offre-parrainage-immobilier" rel="noopener">{{$t('layouts.sponsorshipImmo')}}</a></p>
        <p v-if="sitimmoUser.univers === 'VO'"><a class="link-sponsorship" target="_blank" href="https://www.ubiflow.net/offre-parrainage-automobile" rel="noopener">{{$t('layouts.sponsorshipVo')}}</a></p>
    </div>
    <div class="HeaderItems">
      <template v-if="user">
        <dropdown
                class="HeaderItems-item HeaderItems-item--userInfos"
                trigger="click"
                placement="bottom"
                @command="handleCommand"
                :show-timeout="0"
        >
          <el-button type="reset">
            <div class="sitimmoUser-dropdown">{{ sitimmoUser.nom }}</div>
            <div>
              <ubi-icon name="angle-down" size="11"/>
              <span class="text-primary font-secondary"
              >{{ user.firstname }} {{ user.lastname }}</span
              >
            </div>
          </el-button>
          <dropdown-menu slot="dropdown">
            <dropdown-item command="profile">
              {{$t("layouts.personalInformation") }}
            </dropdown-item>
            <dropdown-item command="users">
              {{$t("layouts.contactBook") }}
            </dropdown-item>
            <dropdown-item command="quotas" v-if="(isSubAdmin || isMainAccount) && isMultiAccounts">
              {{ $t("layouts.quotas") }}
            </dropdown-item>
            <dropdown-item command="exports">
              {{$t("layouts.exports") }}
            </dropdown-item>
            <dropdown-item command="portailClient">
              {{$t("layouts.portailClient") }}
            </dropdown-item>
            <dropdown-item command="signOut">
              {{$t("layouts.logOut") }}
            </dropdown-item>
          </dropdown-menu>
        </dropdown>
      </template>

      <template v-if="user.multiAccounts && (isMainAccount || isSubAdmin || decodedToken.switchedFromUser)">
      </template>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { signOut } from '@/services/auth'
import { Dropdown, DropdownItem, DropdownMenu, Divider } from 'element-ui'
import NotificationsButton from './notifications/NotificationsButton.vue'
import SwitchUserList from './switchUser/SwitchUserList.vue'
import i18next from 'i18next'
import { portailClientConnect } from '@/services/users'
import {$t} from "@/i18n";

const jwtDecode = require('jwt-decode')

export default {
  name: 'GlobalHeader',
  inject: ['browserContext'],
  components: {
    NotificationsButton,
    SwitchUserList,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Divider
  },
  data () {
    return {
    }
  },
  getters: {
    isSubAdmin: (state) => {
      return state.user.roles.includes('ROLE_SUB_ADMIN')
    }
  },
  computed: {
    ...mapGetters(['isMainAccount', 'isSubAdmin', 'isSubUser']),
    menuOpened () {
      return this.$store.getters.getMenuOpened
    },
    isMultiAccounts () {
      return this.user.multiAccounts
    },
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    token () {
      return this.$store.getters.getToken
    },
    spaceToRedirect () {
      // TODO: improve this method
      let space = 'EA_IMMO'
      if (this.sitimmoUser.univers === 'VO') {
        space = 'EA_VO_CLIENT'
      }
      return space
    },
    logoCustomerSpace () {
      if (i18next.language === 'mx') {
        return 'logo_espace_client_ubiflow_es'
      }
      return 'logo_espace_client_ubiflow_' + i18next.language
    },
    decodedToken () {
      return jwtDecode(this.token)
    }
  },
  methods: {
    ...mapActions(['setMenuOpened']),
    toggleMenu () {
      this.setMenuOpened(!this.menuOpened)
    },
    async handleCommand (command) {
      if (command === 'profile') {
        if (this.$ga) {
          this.$ga.event('navigation_permanente', 'clic', 'informations_personnelles', this.sitimmoUser.id)
        }
        this.$router.push({ name: 'profile' })
      }
      if (command === 'signOut') {
        window.localStorage.clear()
        location.reload()
      } else if (command === 'exports') {
        this.$router.push({ name: 'exports' })
      } else if (command === 'users') {
        if (this.$ga) {
          this.$ga.event('navigation_permanente', 'clic', 'carnet_adresse', this.sitimmoUser.id)
        }
        this.$router.push({ name: 'users' })
      } else if (command === 'quotas') {
        this.$router.push({ name: 'quotas' })
      } else if (command === 'portailClient') {
        const response = await portailClientConnect()
        if (response.portailClientConnect) {
          window.open(response.portailClientConnect, '_blank')
        } else {
          this.$message({ type: 'error', message: $t('components.lists.errorOnLoading') })
        }
      }
    }
  },
  watch: {
    $route (to, from) {
      this.setMenuOpened(false)
    }
  }
}
</script>

<style lang="scss">
  @import "@/theme/_bootstrap.scss";

  .Header {
    @extend .pl-5;
    align-items: center;
    background: rgba(15, 55, 65, 0.6);
    color: white;
    display: flex;
    height: 100%;
    justify-content: space-between;

    &-logo {
      min-height: 50px;

      &-img {
        margin-top: -8px;
      }
    }

    .HeaderItems {
      display: flex;
      flex: 1;
      flex-direction: row;
      justify-content: flex-end;
      align-items: stretch;

      &-item {
        @extend .px-4;
        align-items: center;
        background: transparent;
        color: $white;
        display: flex;
        font-size: $font-size-sm-alt;
        justify-content: center;
        position: relative;
        overflow: hidden;

        > * {
          z-index: 1;
        }

        i {
          font-size: $font-size-base-alt * 1.1;

          &.small {
            font-size: $font-size-sm-alt;
          }
        }

        i + span {
          @extend .ml-2;
          color: $blue;
        }

        .el-button {
          color: $white;
        }

        &::before {
          background: darken($black, 8%);
          content: "";
          height: 0;
          left: 50%;
          position: absolute;
          top: 0;
          transform: translate(-50%, -50%);
          transition: border-radius 0.3s, height 0.3s;
          width: 100%;
          z-index: 0;
          border-radius: 10px;
        }

        &:hover {
          &::before {
            height: 200%;
            border-radius: 0;
            transition: border-radius 0.3s, height 0.3s;
          }

          .el-button {
            color: $white;
          }
        }

        &--notifications .NotificationsButton {
          .el-badge__content {
            top: 50%;
            left: 50%;
            right: auto;
            transform: translateY(-120%);
          }

          &-label {
            display: none;
          }
        }

        &--userInfos .el-button,
        &--notifications .el-button {
          @extend .px-4;
          margin-left: map-get($spacers, 4) * -1 !important;
          margin-right: map-get($spacers, 4) * -1 !important;
        }

        &--userInfos .el-button {
          cursor: pointer;
          font-size: $font-size-sm-alt;
          line-height: $line-height-base * 0.9;
          text-align: right;
        }
      }
    }

    .el-divider {
      @extend .mx-0;
      background-color: #35616b;
      align-self: center;
    }

    @include media-breakpoint-down(lg) {
      padding-left: 0 !important; // pl-0

      &::before {
        content: "";
        background: $blue;
        bottom: 0;
        left: 0;
        position: absolute;
        top: 0;
        transition: width 0.3s;
        width: 50px;
        z-index: -1;
      }

      &--menuOpened {
        &::before {
          width: 316px;
        }

        .Header-menu {
          &-icon {
            transform: rotate(90deg);
          }
        }
      }

      &-menu {
        align-items: center;
        background: $blue;
        color: $white;
        display: flex;
        height: 50px;
        justify-content: center;
        position: fixed;
        top: 0;
        width: 50px;

        &-icon {
          transition: transform 0.3s;
          transform: rotate(0);
        }
      }

      &-logo {
        margin-left: 50px;
      }

      .sponsorship p {
        padding: 0 10px 0 19px;
        font-size: 17px;
      }
    }

    @include media-breakpoint-down(md) {
      .sponsorship p {
        padding: 0 10px 0 19px;
        font-size: 15px;
      }
      .HeaderItems {
        &-item {
          &--changeUser .el-button {
            width: 36px;
            height: 36px;
            border: 1px solid $blue;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    @include media-breakpoint-down(sm) {
      background-image: url("~@/assets/header.png");
      @include image-retina("~@/assets/header@2x.png", 2304px, 194px);
      background-position: top left;
      background-repeat: no-repeat;

      flex-direction: column;
      align-items: center;

      .HeaderItems {
        justify-content: space-between;
        width: 100%;

        &-item {
          padding: map-get($spacers, 1) map-get($spacers, 3) !important;
          margin-left: 0 !important;
          margin-right: 0 !important;

          &--userInfos{
            margin-top: -7px;
            .sitimmoUser-dropdown{
              display: none;
            }
            .el-button {
              text-align: left;
              font-size: 14px;
              background-color: rgba(36,64,76, .9);
              &:hover {
                color: $white;
              }
            }

          }
        }

        .el-button {
          padding: 0;
          margin: 0;
        }

      }

      &-logo {
        margin-left: 0;
      }

      .sponsorship{
        height: max-content;
      }

      .sponsorship p {
        font-size: 16px;
      }
    }
  }
  .sponsorship {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    vertical-align: bottom;
  }
  .sponsorship {
    p {
      font-size: 20px;
      font-family: "Dosis", sans-serif;
      font-weight: 500;
      margin-bottom: 10px;
    }
    a {
      text-decoration: none;
      color: $white;
      &:hover {
        color: $blue;
      }
    }
  }
</style>
